<template>
  <div
    :class="DS_FORM_FIELD_GROUP_CLASSES.Root"
    data-cy="ds-form-field__group"
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
import { DS_FORM_FIELD_GROUP_CLASSES } from "@/src/design_system/form_elements/form_field_group/constants/classes";
</script>
